export default __webpack_public_path__ + "static/media/no_notification.52ee0a32.svg";